import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

function DeleteModal() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = (e) => {
        e.preventDefault(); // Prevents the navigation to /logout
        setShow(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        toast.success("Logout success");
        localStorage.clear();
        navigate("/");
    };

    return (
        <>
            {/* Wrap the Logout option in a Link component */}
            <Link to="/logout" onClick={handleShow}>
                <svg
                    width="18"
                    height="21"
                    viewBox="0 0 18 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 0.00976562C10.47 0.00976562 10.86 0.389766 10.86 0.869766V19.1598C10.86 19.6298 10.48 20.0198 10 20.0198C4.11 20.0198 0 15.9098 0 10.0198C0 4.12977 4.12 0.00976562 10 0.00976562Z"
                        fill="black"
                    />
                    <path
                        d="M17.2987 9.54992L14.4587 6.69992C14.1687 6.40992 13.6887 6.40992 13.3987 6.69992C13.1087 6.98992 13.1087 7.46992 13.3987 7.75992L14.9587 9.31992H5.38867C4.97867 9.31992 4.63867 9.65992 4.63867 10.0699C4.63867 10.4799 4.97867 10.8199 5.38867 10.8199H14.9587L13.3987 12.3799C13.1087 12.6699 13.1087 13.1499 13.3987 13.4399C13.5487 13.5899 13.7387 13.6599 13.9287 13.6599C14.1187 13.6599 14.3087 13.5899 14.4587 13.4399L17.2987 10.5899C17.5887 10.3099 17.5887 9.83992 17.2987 9.54992Z"
                        fill="#809199"
                    />
                </svg>
                <span>Log Out</span>
            </Link>

            {/* Modal for confirmation */}
            <Modal
                className="modal-main"
                show={show}
                centered
                size="md"
                onHide={handleClose}
            >
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Log out</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className="modal-form">
                        <p className="delete">
                            Are you sure you want to log out your account?
                        </p>
                        <div className="d-md-flex align-items-center gap-3 mt-4">
                            <button
                                className="cancel-btn"
                                onClick={handleClose}
                                type="button"
                            >
                                Cancel
                            </button>
                            <button className="save-btn" onClick={handleSubmit}>
                                Log Out
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default DeleteModal;
